import { render } from "./SvgVerifiedBadge.vue?vue&type=template&id=fcf61bda&ts=true"
import script from "./SvgVerifiedBadge.vue?vue&type=script&lang=ts"
export * from "./SvgVerifiedBadge.vue?vue&type=script&lang=ts"

import "./SvgVerifiedBadge.vue?vue&type=style&index=0&id=fcf61bda&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__